import { useCallback } from "react";
import { PlayerAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * Custom hook to send player events analytics
 */
export const usePlayerAnalytics = () => {
    /**
     * a React wrapper for sending player analytics events to KMS
     */
    return useCallback(
        (eventType: PlayerAnalyticsType, entryId: string) => {
            document.dispatchEvent(
                new CustomEvent(
                    "kmsPlayerAnalytics",
                    {
                        detail: {
                            eventType,
                            entryId,
                        },
                    }
                )
            );
        },
        []
    );
};
